
import { SaleOrderItemsDTO } from '@gtpl/shared-models/sale-management';
import { Injectable } from '@nestjs/common';
import { Stock } from '../stock.entity';
import { FGReStockData } from './all-re-packorprocess-stock.dto';
import { StockStatus } from './stock-status.enum';
import { StockDto } from './stock.dto';

@Injectable()
export class StockAdapter {
  
  public convertDtoToEntity(  stockDto: StockDto, isUpdate: boolean): Stock {
    console.log(stockDto);
    const stock = new Stock();
    stock.saleOrderId=stockDto.saleOrderId;
    stock.saleOrderItemId=stockDto.saleOrderItemId;
    stock.pallet=stockDto.pallet;
    stock.palletCode=stockDto.palletCode;
    // stock.rackId=stockDto.rackId;
    stock.location=stockDto.location;
    stock.date=stockDto.date;
    stock.totalCartons=stockDto.totalCartons;
    stock.totalPouches=stockDto.totalPouches;
    stock.loosePouches=stockDto.loosePouches;
    stock.totalLoosePouches = stockDto.totalLoosePouches
    stock.status=stockDto.status;
    stock.lotNo=stockDto.lotNo;
    stock.year = stockDto.year
    stock.stockType=stockDto.stockType;
    stock.shift=stockDto.shift;
    stock.code=stockDto.code;
    stock.traceCode=stockDto.traceCode;
    stock.productCategory=stockDto.productCategory;
    if (isUpdate) {
      stock.updatedUser = stockDto.updatedUser;
      stock.stockId = stockDto.stockId;
    } else {
      stock.createdUser = stockDto.createdUser;
      
    if(stockDto.stockType == StockStatus.superDummy){
      stock.allocatedSaleOrderId = stockDto.saleOrderId
      stock.allocatedSaleOrderItemId = stockDto.saleOrderItemId
    }
    }
    stock.brandId=stockDto.brandId;
    stock.productId=stockDto.productId;
    stock.varientId=stockDto.varientId;
    stock.minGrade=stockDto.minGrade;
    stock.maxGrade=stockDto.maxGrade;
    stock.categoryId=stockDto.categoryId;
    stock.pouches=stockDto.pouches;
    stock.pouchWeight=stockDto.pouchWeight;
    stock.uomId=stockDto.uomId;
    stock.stockInQty=stockDto.stockInQty;
    stock.count=stockDto.count;
    stock.plantId=stockDto.unitId;
    stock.packingCompleted=stockDto.packingType;
    stock.palletCapacity=stockDto.palletCapacity;
    stock.pouchesShortage=stockDto.pouchesStatus;
    stock.cartonsShortage=stockDto.cartonsStatus;
    stock.transactionType=stockDto.transactionType;
    stock.shift=stockDto.shift;
    stock.remarks=stockDto.remarks;
    stock.warehouseIncharge=stockDto.warehouseIncharge;
    stock.zoneId = stockDto.zoneId;
    stock.packStyleId = stockDto.packStyleId;
    stock.antibioticTestResult = stockDto.antibioticTestResult
    stock.packageType = stockDto.packageType;
    stock.tareWeight = stockDto.tareWeight;
    stock.quantity = stockDto.quantity;
    stock.stockInType = stockDto.stockInType;
   return stock;
  }
  public convertEntityToDto(stockObject: Stock): StockDto {
    const stockDTO= new StockDto;
    stockDTO.pallet = stockObject.pallet;
    stockDTO.saleOrderId=stockObject.saleOrderId;
    stockDTO.saleOrderItemId=stockObject.saleOrderItemId;
    // stockDTO.rackId=stockObject.rackId;
    stockDTO.location=stockObject.location;
    stockDTO.date=stockObject.date;
    stockDTO.totalCartons=stockObject.totalCartons;
    stockDTO.totalPouches=stockObject.totalPouches;
    stockDTO.loosePouches=stockObject.loosePouches;
    stockDTO.status=stockObject.status;
    stockDTO.lotNo=stockObject.lotNo;
    stockDTO.stockType=stockObject.stockType;
    stockDTO.brandId=stockObject.brandId;
    stockDTO.productId=stockObject.productId;
    stockDTO.varientId=stockObject.varientId;
    stockDTO.minGrade=stockObject.minGrade;
    stockDTO.maxGrade=stockObject.maxGrade;
    stockDTO.categoryId=stockObject.categoryId;
    stockDTO.pouches=stockObject.pouches;
    stockDTO.pouchWeight=stockObject.pouchWeight;
    stockDTO.uomId=stockObject.uomId;
    stockDTO.stockInQty=stockObject.stockInQty;
    stockDTO.count=stockObject.count;
    stockDTO.createdUser=stockObject.createdUser;
    stockDTO.updatedUser=stockObject.updatedUser;
    stockDTO.stockId=stockObject.stockId;
    stockDTO.unitId=stockObject.plantId;
    stockDTO.palletCode=stockObject.palletCode;
    stockDTO.palletCapacity=stockObject.palletCapacity;
    stockDTO.cartonsStatus=stockObject.cartonsShortage;
    stockDTO.pouchesStatus=stockObject.pouchesShortage;
    stockDTO.code=stockObject.code;
    stockDTO.transactionType=stockObject.transactionType;
    stockDTO.traceCode=stockObject.traceCode;
    stockDTO.productCategory=stockObject.productCategory;
    stockDTO.remarks=stockObject.remarks;
    stockDTO.warehouseIncharge=stockObject.warehouseIncharge;
    stockDTO.zoneId=stockObject.zoneId;
    stockDTO.packStyleId=stockObject.packStyleId;
    return stockDTO;
  }

    
  public convertReprocessDtoToEntity(stockDto:FGReStockData, assignedCases:number): Stock {
    console.log(stockDto);
    const stock = new Stock();
    stock.saleOrderId=stockDto.assignedSoId;
    stock.saleOrderItemId=stockDto.assignedSoItemId;
    stock.pallet=stockDto.palletId;
    stock.location=stockDto.locationId;
    stock.date=stockDto.date;
    // stock.quantity=assignedCases;
    stock.status=stockDto.status;
    stock.stockType=StockStatus.SaleOrder;
    stock.updatedUser = '';
    stock.createdUser = '';
    stock.brandId=stockDto.brandId;
    stock.productId=stockDto.productId;
    stock.varientId=stockDto.varientId;
    stock.minGrade=stockDto.minGrade;
    stock.maxGrade=stockDto.maxGrade;
    stock.categoryId=stockDto.categoryId;
    stock.pouches=stockDto.pouches;
    stock.pouchWeight=stockDto.pouchWeight;

   return stock;
  }
}
